export const DirectPaymentStatuses = {
  PROCESSING: 'processing',
  PENDING: 'pending',
  COMPLETED: 'completed',
  FAILED: 'failed',
} as const;

export type DirectPaymentStatus = (typeof DirectPaymentStatuses)[keyof typeof DirectPaymentStatuses];
